import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from '@common/interfaces/id';
import { IID_GENERIC_KO } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IID_Generic_KoState extends EntityState<IID_GENERIC_KO, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_GENERIC_KO })
@InterfaceDataStore(InterfaceName.GENERIC_KO)
export class IID_Generic_KoStore extends EntityStore<IID_Generic_KoState> {
  constructor() {
    super([]);
  }
}
